import React from "react";
import TripianLogo from "../img/tripian-bg.png";
import Model from "@tripian/model";
// import visa from "../img/visa.png";

type Props = {
  theme?: "dark" | "light";
  isLoggedIn: boolean;
  onClickSignUp: () => void;
  onClickPlanYourTrip: () => void;
  t: (value: Model.TranslationKey) => string;
};

const Navbar: React.FC<Props> = ({
  theme = "light",
  isLoggedIn = false,
  onClickSignUp,
  onClickPlanYourTrip,
  t,
}) => {
  return (
    <nav className="absolute z-10 w-full py-4 px-2 md:px-6 flex items-center justify-between">
      <div className="bg-slate-300 w-full rounded-full flex items-center justify-between h-[4.5625rem] py-0 px-2">
        <img
          src={
            theme === "dark"
              ? window.tconfig.IMAGE_PATHS.LOGO_PATH_DARK
              : window.tconfig.IMAGE_PATHS.LOGO_PATH_LIGHT || TripianLogo
          }
          // src={visa}
          alt="Visa logo"
          className="max-h-14 max-w-[10rem] w-auto h-auto p-2 ms-1 md:ms-4"
        />
        <div className="flex items-center">
          {!isLoggedIn && (
            <button
              className="text-primary-color hidden md:block font-semibold hover:underline me-4"
              onClick={onClickSignUp}
            >
              {t("auth.register.title")}
            </button>
          )}
          <button
            className="bg-primary-color text-white font-semibold px-9 py-4 rounded-full transition text-xs md:text-base"
            onClick={onClickPlanYourTrip}
          >
            {t("landing.planYourTrip")}
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
